import { createMuiTheme } from '@material-ui/core/styles';

const widgetTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#0E8BB4'
    },
    secondary: {
      main: '#254052'
    },
    error: {
      main: '#EB5757'
    }
  },
  typography: {
    fontFamily: 'Fira Sans',
    h1: {
      fontSize: '17px',
      lineHeight: '30px',
      fontWeight: 'bold'
    },
    h2: {
      fontSize: '15px',
      lineHeight: '24px',
      fontWeight: 'bold'
    },
    h3: {
      fontSize: '13px',
      lineHeight: '18px',
      fontWeight: 'bold'
    },
    h4: {
      fontSize: '10px',
      lineHeight: '18px',
      fontWeight: 'bold'
    },
    body1: {
      fontSize: '13px',
      lineHeight: '18px',
      color: '#071B27'
    },
    body2: {
      fontSize: '11px',
      fontWeight: 'bold'
    },
    button: {
      textTransform: 'capitalize',
      fontWeight: 500
    }
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '.CalendarDay': {
          position: 'relative',
          padding: 0
        }
      }
    }
  }
});

export default widgetTheme;
